<script>
export default {
  name: 'SectionIcon',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['settings', 'bell', 'work-order', 'status', 'plus'].includes(value),
    },
  },
  computed: {
    iconClass() {
      const baseClass = 'me-2'
      const iconMap = {
        settings: 'bx bx-cog',
        bell: 'bx bx-bell',
        'work-order': 'bx bx-briefcase',
        status: 'bx bx-star',
        plus: 'bx bx-plus',
      }
      return `${iconMap[this.type]} ${baseClass}`
    },
  },
}
</script>

<template>
  <i :class="iconClass" />
</template>
